module.exports = __webpack_public_path__ + "img/logo-light.c00ded02.png";